"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addI18nNamespaceToErrorMessage = void 0;
function addI18nNamespaceToErrorMessage(namespace) {
    return (data) => {
        if (data._embedded && data._embedded.errors) {
            data._embedded.errors.forEach((error) => {
                const firstErrorChar = error.message[0];
                const lastErrorChar = error.message[error.message.length - 1];
                if (firstErrorChar === '{' && lastErrorChar === '}') {
                    const dotsRegex = /\./g;
                    error.message = error.message.slice(1, -1).replace(dotsRegex, '_');
                }
                error.message = `${namespace}:${error.message}`;
            });
        }
        return data;
    };
}
exports.addI18nNamespaceToErrorMessage = addI18nNamespaceToErrorMessage;
//# sourceMappingURL=addI18nNamespaceToErrorMessage.js.map